import { Paper } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import * as React from 'react';
import { Fund } from './type';

const columns = [
  { field: 'id', headerName: 'Folio Number', width: 150 },
  {
    field: 'fundName',
    headerName: 'Fund name',
    flex: 1
  },
  {
    field: 'totalStampDuty',
    headerName: 'Stamp Duty',
    type: 'number',
    width: 120,
  },
  {
    field: 'totalStt',
    headerName: 'STT',
    type: 'number',
    width: 70,
  },
  {
    field: 'reportDayNAV',
    headerName: 'NAV',
    type: 'number',
    width: 100,
  },
  {
    field: 'totalUnits',
    headerName: 'Total Units',
    type: 'number',
    width: 100,
  },
  {
    field: 'reportDayValuation',
    headerName: 'Valuation',
    type: 'number',
    width: 150,
  },
  
];


type Props = {
  funds: Array<Fund>
}
export default function FundDetails({ funds }: Props) {
  const [pageSize, setPageSize] = React.useState(5);
  return (<Paper style={{ width: '100%' }}>
    <DataGrid
      autoHeight
      rows={funds.map(f => ({
        id: f.folioNumber, ...f,
        totalStampDuty: f.transactions
          .reduce((a, c) => a + (c.xnType === 'STAMP_DUTY' ? +c.amount : 0), 0),
          totalStt: f.transactions
          .reduce((a, c) => a + (c.xnType === 'STT' ? +c.amount : 0), 0),
      }))}
      columns={columns}
      pageSize={pageSize}
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
      rowsPerPageOptions={[5, 10, 20]}
      disableSelectionOnClick
    /></Paper>
  );
}
